import AreaFilterDefinition from '../AreaFilterDefinition';
import AttendanceFilterDefinition from '../AttendanceFilterDefinition';
import ContinentFilterDefinition from '../ContinentFilterDefinition';
import { CountryFilterDefinition } from '../CountryFilterDefinition';
import DisciplineFilterDefinition from '../DisciplineFilterDefinition';
import DurationFilterDefinition from '../DurationFilterDefinition';
import { EducationLevelFilterOptionValue } from '@studyportals/search-filters';
import FormatFilterDefinition from '../FormatFilterDefinition';
import PhdDegreeTypeFilterDefinition from './PhdDegreeTypeFilterDefinition';
import { PortalDefinition } from '../PortalDefinition';
import TuitionFeeFilterDefinition from '../TuitionFeeFilterDefinition';
import PhdSpecialProgrammesFilterDefinition from './PhdSpecialProgrammesFilterDefinition';
import OrganisationFilterDefinition from '../OrganisationFilterDefinition';

class PhdPortalDefinition extends PortalDefinition {
	public constructor() {
		super(
			[
				OrganisationFilterDefinition,
				AttendanceFilterDefinition,
				PhdDegreeTypeFilterDefinition,
				DisciplineFilterDefinition,
				DurationFilterDefinition,
				FormatFilterDefinition,
				TuitionFeeFilterDefinition,
				PhdSpecialProgrammesFilterDefinition,
				AreaFilterDefinition,
				ContinentFilterDefinition,
				new CountryFilterDefinition()
			],
			['30', '82', '27', '24', '12'],
			'PhD programmes',
			'phd',
			EducationLevelFilterOptionValue.PHD,
			'PhDs'
		);
	}
}

export default new PhdPortalDefinition();
